import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import api from "@/api/index"
import Axios from "axios"
import "@mdi/font/css/materialdesignicons.css"
import "animate.css"
import vuetify from "@/libs/vuetify"
import message from "./components/message"
import modal from "./components/modal"
import PlayVideo from "./components/video"
import vueg from "vueg"
import Datetime from "vue-datetime"
import "vue-datetime/dist/vue-datetime.css"
import "@/assets/font/iconfont.css"
import vuePicturePreview from "vue-picture-preview"
import "@/assets/style/index.scss"
import { generateGUID } from "./api/net/util"

Vue.use(Datetime)
Vue.use(modal, { vuetify })
Vue.use(message)
Vue.use(vueg, router)
Vue.use(vuePicturePreview)
Vue.use(PlayVideo)
Vue.config.productionTip = false

Vue.prototype.$api = api
Vue.prototype.$color = "#CE2664"
Vue.prototype.$error = "#F44336"
Vue.prototype.$success = "#4CAF50"
Vue.prototype.$primary = "#03A9F4"
Vue.prototype.$default = "#BDBDBD"

window.Vue = new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")

window.onerror = (error) => {
  Axios.request({
    headers: {
      "X-Seq-ApiKey": "UrEWi6ll8xlyE0piIMq9",
    },
    method: "POST",
    url: "https://seq-dev.yamimeal.com/api/events/raw?clef",
    data: {
      "@t": new Date().toISOString(),
      "@l": "Error",
      Application: "OXYGEN-MANAGEMENT",
      "@mt": "oxygen-management error event",
      CorrelationId: generateGUID(),
      errorData: error,
    },
  })
}
